export default tracking => {
    const trackEvents = tracking.querySelectorAll('[data-track]');

    if(trackEvents.length > 0)
        for (const trackEvent of trackEvents) {

            let isRevealTracking = trackEvent.dataset.trackReveal ? true : false;
            let revealBlock = document.createElement('span');
            let revealLabel = document.createElement('span');

            if(isRevealTracking){
                revealLabel.innerHTML = trackEvent.dataset.trackReveal;
                revealBlock.classList.add('reveal');
                revealLabel.classList.add('reveal-label');
                revealBlock.appendChild(revealLabel);
                trackEvent.appendChild(revealBlock);
            }

            trackEvent.addEventListener('click', (el) => {

                if(isRevealTracking && !trackEvent.classList.contains('revealed')){
                    revealBlock.parentNode.removeChild(revealBlock);
                    trackEvent.classList.add('revealed');
                }

                if (!window.consent) {
                    return;
                }

                const isPageLink = (trackEvent.tagName == "A" && trackEvent.getAttribute('target') !== "_blank") ? true :false;
                const isBlankLink = (trackEvent.tagName == "A" && trackEvent.getAttribute('target') == "_blank") ? true :false;

                if (!isBlankLink) {
                    el.preventDefault();
                }

                let trackData = el.currentTarget.dataset.track.split(';');

                let trackAction = trackData[0];
                let trackCategory = trackData[1];
                let trackLabel = trackData[2];

                gtag('event', trackAction, {'event_category': trackCategory,'event_label': trackLabel});

                if (trackLabel == "demande-dinscription-journees-decouverte") {
                    fbq('track', 'Lead');
                }

                if (isPageLink) {
                    document.location = trackEvent.getAttribute('href');
                }

            });
        }
}